// extracted by mini-css-extract-plugin
module.exports = {"unassignUserButton":"UserAssigner_unassignUserButton__O_RJF"};